import { FC } from 'react';

import { useI18nContext } from '../../hooks/contexts/i18n.context';
import { useModalContext } from '../../hooks/contexts/modal.context';
import * as Styles from './privacy-botafogo-modal.styles';

const PrivacyBotafogoModal: FC = () => {
  const { translate } = useI18nContext();
  const { toggleModal } = useModalContext();

  return (
    <Styles.Body>
      <Styles.Text>
        {translate(['INFORMATION', 'PRIVACYBOTAFOGO_WARNING_TITLE'])}
      </Styles.Text>
      <Styles.TextInfo>
        {translate(['INFORMATION', 'PRIVACYBOTAFOGO_WARNING_MESSAGE'])}
        <Styles.Link href="https://static.botafogo.com.br/upload/3e814199-ad9c-48b3-ae7e-7719b6e0a718.pdf" target='_blank'>
          {translate(['INFORMATION', 'PRIVACYBOTAFOGO_WARNING_CLICK'])}
        </Styles.Link>
      </Styles.TextInfo>
      <Styles.TextInfo>
        {translate(['INFORMATION', 'PRIVACYBOTAFOGO_WARNING_MESSAGE_SECOND'])}
      </Styles.TextInfo>
      <Styles.BtnContainer>
        <Styles.CutomBtn onClick={() => toggleModal({ open : false })}>
          {translate(['INFORMATION', 'UNDERSTOOD'])}
        </Styles.CutomBtn>
      </Styles.BtnContainer>
    </Styles.Body>
  );
};

export default PrivacyBotafogoModal;
